import { render, staticRenderFns } from "./PublicSample.vue?vue&type=template&id=0b98157f&scoped=true"
import script from "./PublicSample.vue?vue&type=script&lang=js"
export * from "./PublicSample.vue?vue&type=script&lang=js"
import style0 from "./PublicSample.vue?vue&type=style&index=0&id=0b98157f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b98157f",
  null
  
)

export default component.exports